import { toast } from 'react-toastify';

const SuccessAlert = (content: string, duration = 15, onClose?: () => void) => toast.success(content, { autoClose: duration * 1000, onClose });
// TODO: Make this closable - switch from Message to Alert or Notification
const ErrorAlert = (content: string, duration = 15, onClose?: () => void) => toast.error(content, { autoClose: duration * 1000, onClose });
const InfoAlert = (content: string, duration = 15, onClose?: () => void) => toast.info(content, { autoClose: duration * 1000, onClose });

export { SuccessAlert, ErrorAlert, InfoAlert };
